<template lang="pug">
    section#textolegal
        div.wrapper
            p
                |Regras gerais:
                br
                |1 - Para garantir a conclusão do curso dentro do mesmo prazo da sua faculdade de origem, é condição:
                |a) que a transferência para a UniFAEL seja para o mesmo curso de origem; b) realize a entrega dos documentos
                |de Histórico Escolar parcial e Ementário das disciplinas do curso de origem que deve ser entregue no ato da
                |inscrição; c) O aluno alcance aproveitamento mínimo em todas as disciplinas curriculares, sem reprovações;
                |d) O aluno deve cumprir com a carga horária de atividades complementares e, quando houver previsão no curso pretendido,
                |a realização de estágios obrigatórios e a finalização do TCC dentro do calendário acadêmico.
                |e) obrigatoriamente seja respeitado o tempo mínimo de integralização do curso na UniFAEL (isto é, tempo de duração do curso da UniFAEL).
                |Caso o tempo de duração do cursos da IES de origem seja diferente/menor do que na UniFAEL,
                |é obrigatório ao aluno o cumprimento do tempo de integralização/duração do curso na UniFAEL.
                br
                br
                |2 - Consulte o Regulamento da Campanha com as condições para manter seu desconto,
                a(href="https://media.fael.edu.br/regulamentos/regulamento-vem-todo-mundo.pdf") clicando aqui!
                br
                br
                |3 - Para garantir o aproveitamento de disciplinas, é condição que o candidato realize a entrega dos documentos:
                |Programas das disciplinas cursadas com aprovação, devidamente assinados pelo Serviço de Graduação da Unidade de origem,
                |Histórico escolar de graduação devidamente assinados pelo Serviço de Graduação da Instituição de Ensino Superior de origem
                |e Diploma de graduação – quando o candidato já tiver um curso concluído. Caso não entregue estes documentos, o aluno
                |não terá direito ao aproveitamento de disciplinas pela falta de documentos mínimos comprobatórios.

</template>

<script>
export default {
    name: "section-textolegal"
}
</script>

<style lang="stylus" scoped src="./Textolegal.styl"></style>
